import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TareaPodaModel } from '../../../../../models/tareas/tarea-poda.model';
import { MtoReactiveFormComponent } from '../../mto-reactive/mto-reactive-form.component';
import { TareasMtoPodaFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-tareas-mto-poda-form',
    standalone: false,
    templateUrl: './tareas-mto-poda-form.component.html',
    styleUrls: ['./tareas-mto-poda-form.component.scss'],
})
export class TareasMtoPodaFormComponent extends MtoReactiveFormComponent<TareaPodaModel, TareasMtoPodaFormDefinition> {
    constructor(
        route: ActivatedRoute,
        dashboard: DashboardService,
        fincasApi: FincasApiService,
        clientesApi: ClientesApiService,
        trabajadoresApi: TrabajadoresApiService,
        tareasApi: TareasApiService,
        router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi,
            clientesApi,
            trabajadoresApi,
            tareasApi.mtoPoda.PUT,
            tareasApi.mtoPoda.POST,
            tareasApi.mtoPoda.GET,
            'poda',
            'Actualizar Tarea Poda',
            'Realizar Tarea Poda',
            'Duplicar Tarea Poda',
            {
                loadingLabel: 'Cargando datos del formulario de poda...',
                errorContext: 'poda',
            },
        );
    }

    protected createFormDefinition(): TareasMtoPodaFormDefinition {
        return new TareasMtoPodaFormDefinition(this.getType(), this.model);
    }
}
